import React from 'react'
import { SkeletonText, SkeletonButton } from '@offerzen/pinata'
import SkeletonSection from '../SkeletonSection'
import SkeletonWorkAuthorisationsList from '../SkeletonWorkAuthorisationsList'
import SkeletonWorkAuthorisationsAdd from '../SkeletonWorkAuthorisationsAdd'

import styles from './styles'

const SkeletonWorkAuthorisation = () => (
  <SkeletonSection titleWidth={240} className={styles.wrapper}>
    <SkeletonText theme="dark" className={styles.countrylist} />
    <SkeletonText theme="dark" className={styles.helpText} />
    <SkeletonButton theme="dark" className={styles.link} />
    <SkeletonWorkAuthorisationsList theme="dark" />
    <SkeletonWorkAuthorisationsAdd theme="dark" />
  </SkeletonSection>
)

export default SkeletonWorkAuthorisation
